/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {completeInviteFriends} from '../api'

export const useMutationCompleteInviteFriends = createReactQueryMutationHook('completeInviteFriends', completeInviteFriends)
